import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useTranslate } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import { actionSweetAlert } from 'store/actions/commonActions';
import { actionDeleteAccountRequest } from 'store/actions/usersActions';
// reactstrap components
import { Button } from 'reactstrap';

const UserDeleteForm = () => {
  const t = useTranslate('settings');
  const t2 = useTranslate('user-delete-form');
  const dispatch = useDispatch();

  return (
    <div className="setting-section account-deletion-section">
      <h5 className="general-card-subtitle">{t2('title')}</h5>
      {t2('save-data-notice')}
      <br />
      <Button
        type="danger"
        color="danger"
        name="btn-real-delete-user"
        onClick={() => {
          dispatch(
            actionSweetAlert(
              <SweetAlert
                custom
                customIcon="/General/icons/warning-sign-orange.svg"
                title={"Sind Sie sicher?"}
                onConfirm={() => { }}
                customButtons={
                  <>
                    {/*Custom buttons for more control*/}
                    <Button
                      className="mb-3"
                      color="danger"
                      name="btn-alert-delete"
                      size="lg"
                      onClick={() => {
                        dispatch(actionDeleteAccountRequest());
                        dispatch(actionSweetAlert(null));
                      }}
                    >
                      {t('btn-yes')}
                    </Button>
      
                    <Button
                      className="mb-3 ml-2"
                      color="info"
                      size="lg"
                      name="btn-alert-cancel"
                      onClick={() => dispatch(actionSweetAlert(null))}
                    >
                      {t('btn-no')}
                    </Button>
                  </>
                }
              >
                {t2('delete-account-disclaimer')}
              </SweetAlert>
            )
          );
        }}
      >
        {t2('delete-account')}
      </Button>
    </div>
  );
};


export default UserDeleteForm;
